<template>
    <div class="login-page">
      <div class="left-section">
        <!-- 左边的图片 -->
        <img src="@/assets/left.png" alt="login-image">
      </div>
      <div class="right-section">
        <h1>LOGIN TO HQS</h1>
        <!-- 登录表单 -->
        <form @submit.prevent="login">
          <input placeholder="Please enter your email" style="width: 220px;" type="text" id="username" v-model="username" required>
          <br>
          <input placeholder="Please enter your password" style="margin-top:20px;width: 220px;" type="password" id="password" v-model="password" required>
          <br>
          <button type="submit" style="margin-top: 20px;width: 220px;background-color:#12416A;color: white;font-weight: 400;">Login</button>
        </form>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        username: '',
        password: '',
        loggedIn: false
      };
    },
    methods: {
      login() {
        console.log(this.username);
        console.log(this.password);
        // 检查用户名和密码
        if (this.username === 'austin@tesla.com' && this.password === 'VbT9lf2w') {
          // 登录成功，跳转到指定的页面
          window.location.href = 'https://lookerstudio.google.com/u/0/reporting/a89937dc-2497-4fd7-b9f2-54fb8d61a42e/page/MwhvD';
          this.loggedIn = true;
        } else {
          // 登录失败
          alert('Invalid username or password');
        }
      }
    }
  };
  </script>
  
  <style scoped>
  .login-page {
    display: flex;
    height: 100vh;
  }
  
  .left-section {
    flex: 6;
    background-color: #12416A;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .left-section img {
    max-width: 100%;
    max-height: 100%;
  }
  
  .right-section {
    flex: 4;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 20px;
  }
  
  .right-section h2 {
    margin-bottom: 20px;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/LoginPage.vue